import React from 'react';
import POSSpecificSettings from './POSSpecificSettings/index';
import CommonSettings from './CommonSettings';
import { PrimaryButton } from '@/components/Buttons'; 

const Settings = ({ onDisconnect, fullLocationDetail }) => {
  // Use fullLocationDetail passed from parent component
  const settings = fullLocationDetail?.api_credentials;
  const handleSave = () => {
    // TODO: Implement save functionality
  };

  return (
    <div>
      {/* POS Specific Settings */}
      <POSSpecificSettings settings={settings} onDisconnect={onDisconnect} />
      
      {/* Common Settings */}
      <div className="mt-12">
        <CommonSettings settings={settings} />
      </div>

      <div className="flex justify-end pt-4 border-t border-slate-200 dark:border-slate-700">
          <PrimaryButton onClick={handleSave}>
            Save Settings
          </PrimaryButton>
        </div>
    </div>
  );
};

export default Settings; 